

















export default {
  name: 'IconBox',
  props: {
    source: {
      type: String,
      default: null,
    },
  },
};
